
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Http, Response } from '@angular/http';
import { HttpUtilityService } from '../../../shared/http-utility.service';
import { FeedMetadataItem } from './models/feed-metadata-item.model';
import { FeedMetadataService } from './feed-metadata.service';
import { FeedMetadataDetail } from './models/feed-metadata-detail.model';
import { EventLoggerService} from '../../../shared/event-logger.service';
import { ErrorManagerService } from '../../../shared/error-handling/error-manager.service';

@Injectable()
export class FeedMetadataServiceImpl implements FeedMetadataService {

    constructor(private http: Http, private httpUtility: HttpUtilityService, private eventLoggerService: EventLoggerService, private errorManager: ErrorManagerService) { }

    list(): Observable<FeedMetadataItem[]> {
        const url: string = this.httpUtility.buildUrl('');
        return this.http.get(url, {
          headers: this.httpUtility.getHeaders()
        })
        .map(this.processResponse);
    }

    listFrequentlyAccessed(): Observable<FeedMetadataItem[]> {
        const url: string = this.httpUtility.buildUrl('?isFrequentlyAccessed=true&startRow=1&rowCount=100');
        return this.http.get(url, {
          headers: this.httpUtility.getHeaders()
        })
        .map(this.processResponse);
    }

    search(search: string): Observable<FeedMetadataItem[]> {
        const url: string = this.httpUtility.buildUrl(`?search=${search}&isactive=true&startRow=1&rowCount=100`);
        return this.http.get(url, {
          headers: this.httpUtility.getHeaders()
        })
        .map(this.processResponse);
    }

    get(feedName: string): Observable<FeedMetadataDetail> {
        const url: string = this.httpUtility.buildUrl(feedName + '/metadata');
        return this.http.get(url, {
          headers: this.httpUtility.getHeaders()
        })
        .map(this.processDetailResponse);
    }

    private processResponse(response: Response) {
        if (response.status < 200 || response.status >= 300) {
            const error = new Error(response.status + ':' + response.json());
            this.eventLoggerService.logError(error, 'Error in MetadataService', {});
            if (!this.errorManager.handleError(error, error.name, '', error.message)) {
                return Observable.throw(error);
            }

        }

        const body = response.json();
        return body.items || {};
    }

    private processDetailResponse(response: Response) {
        if (response.status < 200 || response.status >= 300) {
            const error = new Error(response.status + ':' + response.json());
            this.eventLoggerService.logError(error, 'Error in MetadataService', {});
            if (!this.errorManager.handleError(error, error.name, '', error.message)) {
                return Observable.throw(error);
            }
        }

        const body = response.json();
        return body || {};
    }
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/shared/feed-metadata-impl.service.ts